<template>
  <div id="" class="pop-up-wrap-user">
    <div class="pop-up-user button-wrap2 xlg4">
            <div class="pop-header-user">
                <span class="title03">{{menuObj.name}}<span class="price">
                  {{menuObj.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}원
                </span>
                <span class="title-disc">
                  ({{addPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}원)</span>
                </span>
                <button
                  class="btn-pop-close"
                  id="btnRegisterClose"
                  @click="$.emit('close')"
                >
                  닫기<span class="overlay"></span>
                </button>
            </div>
            <div class="pop-body3 admin-ph17">
                <div class="option-list-box">
                    <div class="option-list-wrap">
                        <ul class="option-tag-list trans-scroll">
                            <li class="set-opt" v-for="(item,index) in setMenuDefaultItemList" :key="index">{{item.name}}</li>
                        </ul>
                        <button type="button" class="btn-more" @click="optionListShow()"></button>
                    </div>
                </div>
                <div class="lst-option-wrap set-menu admin-mt16">
                    <div class="lst-option">
                        <!-- page 1 -->
                        <div class="lst-option--col type03">
                            
                            <div
                              class="box--bdr"
                              v-for="(option, index) in setMenuOptionList.slice(
                                (setMenuCurrentPage - 1) * setMenuPageCount,
                                setMenuCurrentPage * setMenuPageCount
                              )"
                              :key="index"
                              :class="{ on: activeSideMenu == index }"
                              @click="setMenuDetail(option, index)"
                            >
                            
                            <div class="box--hdr">{{ option.sideMenuName }}</div>
                                <ul class="box--body">
                                    <li><div class="ellipsis02"><template v-if="option.desc == null || option.desc == ''">선택안함</template>{{option.desc}}</div></li>
                                </ul>
                                <div class="box--ftr">{{ option.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}</div>
                            </div>
                        </div>
                        <!-- //page 1 -->
                        <div class="posi-btn2">
                            <button class="swipe-btn-up">위로<span class="overlay"></span></button>
                            <button class="swipe-btn-down">아래로<span class="overlay"></span></button>
                        </div>
                        
                        <div class="swiper-pagination--col">
                            <span class="bullet on"></span>
                        </div>
                    </div>
    
                    <div class="lst-option">
                        <!-- 바둑판 형 리스트: type은 박스 사이즈 -->
                        <!-- page 1 -->
                        <div class="list-option--grid-box">
                            <div class="select-text">
                                <template v-if="targetObj.minmaxYn">
                                  <label class="option-tag optionred">필수</label>
                                </template>
                                <template v-if="targetObj.minmaxYn == false">
                                  <label class="option-tag option">선택</label>
                                </template>
                                <span>최소{{targetObj.minNum}}개/최대{{targetObj.maxNum}}개</span>
                            </div>
                            <div class="lst-option--grid type01">
                                <div
                                  class="box--shd col03"
                                  v-for="(item, index) in tempItemList.slice(
                                    (itemCurrentPage - 1) * itemPageCount,
                                    itemCurrentPage * itemPageCount
                                  )"
                                  :key="index"
                                  :class="{ on: item.qty > 0 }"
                                  @click="setMenuItem(item, 1)"
                                >
                                      <span class="box--hdr">{{item.name}}</span>
                                      <div class="box--ftr static">{{item.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</div>
                                      <div class="box--ftr-amount" v-if="targetObj.numberYn">
                                          <button type="button" class="btn-option-minus" @click="setMenuItem(item, -1)"><span class="overlay"></span></button>
                                          <span type="text" class="option-amount">{{item.qty}}</span>
                                          <button type="button" class="btn-option-plus" @click="setMenuItem(item, 1)"><span class="overlay"></span></button>
                                      </div>
                                </div>


                                <div class="box--shd empty" v-for="i in (11-tempItemList.slice((itemCurrentPage - 1) * itemPageCount,itemCurrentPage * itemPageCount).length)" :key=i></div>
                            </div>
                            <div class="swiper-pagination static">
                                <span class="bullet on"></span>
                            </div>
                            <!-- // page 1 -->
                            <div class="swipe-btn-area">
                                <button class="swipe-btn-prev port option-btn-prev">이전<span class="overlay"></span></button>
                                <button class="swipe-btn-next port option-btn-next">다음<span class="overlay"></span></button>
                            </div>
                        </div>
                        <div class="pop-btn-area btn02">
                            <!-- [팝업버튼 크기] .btn-pop: 100%, .btn-pop.btn-half: 50%, .btn-pop.btn-third: 33.33%, .btn-pop.btn-fourth: 25% -->
                            <button type="button" class="btn-pop btn-third btn-main" @click="reset">초기화<span class="overlay"></span></button>
                            <button type="button" class="btn-pop btn-half btn-submit" @click="setBaskets">완료<span class="overlay"></span></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="dimed"></div>
  </div>
</template>

<script>
import _ from "lodash";
import jsonSetMenuDefaultItem from "@/assets/json/SetMenuDefaultItem.js";

export default {
  name: "orderMenuSelectOption",
  props: {
    menuObj: Object,
  },
  data() {
    return {
      activeSideMenu : 0,
      setMenuOptionList: [],
      setMenuItemList: [],
      tempItemList: [],
      setMenuCurrentPage: 1,
      setMenuPageCount: 4,
      itemCurrentPage:1,
      itemPageCount:11,
      activeSideItem : 0,
      targetObj : {},
      addPrice : 0,
      setMenuDefaultItemList: [],
    };
  },
  methods: {
    optionListShow() {
      if (document.querySelector(".option-list-wrap").classList.contains("show")) {
          document.querySelector(".option-list-wrap").classList.remove("show");
          document.querySelector('.option-tag-list').scrollTop = 0;
      } else {
          document.querySelector(".option-list-wrap").classList.add("show");
      }
    },
    setMenuDetail(option,index){
      this.activeSideMenu = index;
      this.activeSideItem = -1;

      this.targetObj = option;

      this.tempItemList = this.setMenuItemList.filter((item) => {
        return item.sideMenuIdx == option.sideMenuIdx;
      });
    },
    setMenuItem(item,index) {
      if(this.targetObj.numberYn == false) {
        if(item.qty == 1) {
          item.qty = 0;
          this.targetObj.desc = '';
          this.targetObj.price = 0;

        }else{
          for(let i=0; i<this.tempItemList.length; i++){
            this.tempItemList[i].qty = 0;
          }
          item.qty++;

          this.targetObj.desc = item.name;
          this.targetObj.price = item.price;
        }

      }
      else if(this.targetObj.numberYn) {
        if((item.qty == 0 && index == -1) == false) {
          let totalQty = index;
          for(let i=0; i<this.tempItemList.length; i++){
            totalQty += this.tempItemList[i].qty;
          }
          
          if(totalQty > this.targetObj.maxNum && this.targetObj.minmaxYn){
            this.$emit("popupOpen", "안내",`${this.targetObj.sideMenuName}분류에서 최대선택가능한<br/>옵션의 수량은 ${this.targetObj.maxNum}개입니다.`);
            return false;
          }else{
            item.qty += index;
            
            let distribute = 0;
            let name = item.name;
            let price = 0;
            for(let i=0; i<this.tempItemList.length; i++){
               price += (this.tempItemList[i].qty * this.tempItemList[i].price);
               
               if(this.tempItemList[i].qty>0){
                distribute++;
                
                if(index == -1) name = this.tempItemList[i].name;
               }
            }

            let desc = name;
            if(distribute > 1) desc = name + "외" + (distribute-1) + "개"
            
            this.targetObj.desc  = totalQty == 0 ? "" : desc;
            this.targetObj.price = price;
          }
        }
      }
      let totalPrice = 0;
      for(let i=0; i<this.setMenuItemList.length; i++){
         totalPrice += (this.setMenuItemList[i].qty * this.setMenuItemList[i].price);
      }
      this.addPrice = totalPrice;
      event.stopPropagation();
    },
    reset() {
      for(let i =0; i<this.setMenuOptionList.length; i++){
        this.setMenuOptionList[i].desc = "";
        this.setMenuOptionList[i].price = 0;
      }
      
      for(let i =0; i<this.setMenuItemList.length; i++){
        this.setMenuItemList[i].qty = 0;
      }
    },
    setBaskets() {

      let flagIdx = -1;
      // validate 체크
      for(let i =0; i<this.setMenuOptionList.length; i++){
        
        if(this.setMenuOptionList[i].minmaxYn && this.setMenuOptionList[i].minNum > 0){
          let count = 0;
          for(let j =0; j<this.setMenuItemList.length; j++){
            if((this.setMenuOptionList[i].sideMenuIdx == this.setMenuItemList[j].sideMenuIdx) && this.setMenuItemList[j].qty>0) count++;
          }

          if(this.setMenuOptionList[i].minNum > count){
            this.$emit("popupOpen", "안내",`${this.setMenuOptionList[i].sideMenuName}분류에서 최소 ${this.setMenuOptionList[i].minNum}개 옵션상품을 선택하세요.`);
            return false;
          }
        }
      }

      let tempList = [];
      for(let i =0; i<this.setMenuDefaultItemList.length; i++){
        if(this.setMenuDefaultItemList[i].selectYn == false){
           var obj = {
                selectItemCd : "",
                selectItemCnt	: this.setMenuDefaultItemList[i].qty,
                selectItemDiscount : 0,
                selectItemNm	: this.setMenuDefaultItemList[i].name,
                selectItemPrice	: this.setMenuDefaultItemList[i].price
            }
            tempList.push(obj);
        }
      }

      for(let i =0; i<this.setMenuItemList.length; i++){
        if(this.setMenuItemList[i].qty > 0){
            var obj = {
                selectItemCd : "",
                selectItemCnt	: this.setMenuItemList[i].qty,
                selectItemDiscount : 0,
                selectItemNm	: this.setMenuItemList[i].name,
                selectItemPrice	: this.setMenuItemList[i].price
            }
            tempList.push(obj);
        }
      }
      
      this.$emit("setBasketOrder", tempList);
      this.$.emit("close");
    },
    
  },
  watch: {},
  computed: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    let tempOptionList  = _.cloneDeep(this.$store.getters.getSetMenuOptionList);
    let tempItemList    = _.cloneDeep(this.$store.getters.getSetMenuItemList);

    this.setMenuOptionList = tempOptionList.filter((item) => {
        return item.setMenuIdx == this.menuObj.setMenuIdx;
    });

    this.setMenuItemList = tempItemList.filter((item) => {
        return item.setMenuIdx == this.menuObj.setMenuIdx;
    });
    
    this.setMenuDefaultItemList = jsonSetMenuDefaultItem.data.setMenuDefaultItemList.filter((item) => {
        return item.setMenuIdx == this.menuObj.setMenuIdx;
    });


    this.setMenuDetail(this.setMenuOptionList[0],0)
  },
  unmounted() {},
  components: {},
};
</script>

<style src="@/assets/css/style.css" scoped></style>
<style scoped>
.lst-option-wrap.set-menu .list-option--grid-box .select-text .option-tag.optionred{
    background: #ffc9c9;
    color: #a90000;
}
</style>


